module.exports = "/_next/static/images/3ff534e2efc8242911b544e0f9ce2036-people.svg";